exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".govuk-select.govuk-select--icons {\n  font-family: \"Font Awesome 5 Free\", \"nta\", Arial, sans-serif;\n}\n", ""]);

// exports
